import { render, staticRenderFns } from "./flag_visible.vue?vue&type=template&id=236b23c6"
import script from "./flag_visible.vue?vue&type=script&lang=ts"
export * from "./flag_visible.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports